export default __webpack_public_path__ + "static/services-img-2-270e7bd31aaa14034b37b46001354b6f.png";